module.exports = __webpack_public_path__ + "img/CH00-006-007.47215674.jpg";